<template>
	<section class="migracao-container">
		<div class="migracao-card">
			<div class="migracao-icon">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="34"
					height="34"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<path d="M5 12h14" />
					<path d="m13 6 6 6-6 6" />
				</svg>
			</div>

			<h1 class="migracao-title">Esta página foi migrada</h1>

			<p class="migracao-text">
				O gerenciamento de componentes não é mais feito por aqui. Ele foi migrado para o novo
				sistema. Utilize o endereço abaixo para continuar.
			</p>

			<a class="migracao-button" :href="novaUrl" target="_blank" rel="noopener noreferrer">
				Acessar o novo sistema
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="16"
					height="16"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					<path d="M15 3h6v6" />
					<path d="M10 14 21 3" />
					<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
				</svg>
			</a>

			<a class="migracao-link" :href="novaUrl" target="_blank" rel="noopener noreferrer">
				{{ novaUrl }}
			</a>
		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {
			novaUrl: 'https://dpc.aglets.com.br//pages//b2b/componentes/index.php',
		};
	},
};
</script>

<style lang="scss" scoped>
@import '~@/style/Global.css';

.migracao-container {
	width: 100%;
	min-height: 70vh;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
}

.migracao-card {
	width: 100%;
	max-width: 520px;
	background-color: var(--white-color);
	border: var(--default-border);
	border-radius: 16px;
	box-shadow: var(--default-shadow);
	padding: 48px 40px;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.migracao-icon {
	width: 72px;
	height: 72px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--primary-color);
	background-color: #09af5f1a;
	margin-bottom: 24px;
}

.migracao-title {
	font-size: 22px;
	font-weight: 700;
	color: #001f60;
	margin: 0 0 12px;
}

.migracao-text {
	font-size: 15px;
	line-height: 1.6;
	color: #6b7280;
	margin: 0 0 28px;
	max-width: 400px;
}

.migracao-button {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	background-color: var(--primary-color);
	color: var(--white-color);
	font-size: 15px;
	font-weight: 600;
	text-decoration: none;
	padding: 12px 24px;
	border-radius: var(--default-border-radius);
	transition: var(--default-transition);
	box-shadow: 0 6px 14px 0 #09af5f40;
}

.migracao-button:hover {
	filter: brightness(0.95);
	transform: translateY(-1px);
}

.migracao-link {
	margin-top: 18px;
	font-size: 13px;
	color: var(--primary-color);
	word-break: break-all;
	text-decoration: none;
}

.migracao-link:hover {
	text-decoration: underline;
}
</style>
